import { useEffect } from 'react';
import { Phone, Mail, MapPin, MessageCircle, Clock } from 'lucide-react';
import { BrandHero, SectionHeader } from '@/components/brand/BrandKit';
import { ContactForm } from '@/components/contact/ContactForm';

const CHANNELS = [
  { icon: Phone, title: 'اتصل بنا', value: '800 364', sub: 'خط مجاني · على مدار الساعة', href: 'tel:800364' },
  { icon: MessageCircle, title: 'واتساب', value: '+971 800 364', sub: 'ردود سريعة في أوقات العمل', href: 'https://wa.me/971800364', external: true },
  { icon: Mail, title: 'البريد الإلكتروني', value: 'wemoveyou@eurogulf.ae', sub: 'رد خلال يوم عمل واحد', href: 'mailto:wemoveyou@eurogulf.ae' },
  { icon: MapPin, title: 'المقر الرئيسي', value: 'القوز ٣، دبي', sub: 'الإمارات العربية المتحدة', href: 'https://maps.google.com/?q=Eurogulf+Mobility+Group+Al+Quoz+Dubai', external: true },
];

export default function ContactPageAr() {
  useEffect(() => { document.title = 'اتصل بنا | مجموعة يوروجلف للتنقل'; }, []);
  return (
    <div dir="rtl" data-testid="contact-page-ar">
      <BrandHero testid="ar-contact-hero" chip="تواصل معنا" title="أخبرنا كيف يمكننا أن ننقلك." lead="سواء كان استفساراً عن تأجير سيارة، أو أسطولاً للشركات، أو سائقاً خاصاً، أو نقلاً بالحافلات، يعود إليك أحد المختصين خلال يوم عمل واحد."
        image="/brand/woman-phone-car.jpg" position="center 40%" />
      <section className="bg-white border-b border-black/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-black/5">
          {CHANNELS.map((c) => (
            <a key={c.title} href={c.href} target={c.external ? '_blank' : undefined} rel={c.external ? 'noopener noreferrer' : undefined} className="group bg-white p-6 transition-colors hover:bg-[#FFF4ED]/70">
              <c.icon className="w-5 h-5 text-[#EE5A01]" />
              <p className="mt-4 font-heading font-bold text-[11px] tracking-wider text-[#666666]">{c.title}</p>
              <p className="mt-1 font-heading font-bold text-base text-[#121212] group-hover:text-[#EE5A01] transition-colors" dir="ltr">{c.value}</p>
              <p className="mt-1 font-body text-xs text-[#666666]">{c.sub}</p>
            </a>
          ))}
        </div>
      </section>
      <section className="bg-[#FAFAFA] py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <SectionHeader compact chip="أرسل استفسارك" title="نموذج واحد لكل احتياجات التنقل." desc="اختر نوع الاستفسار، وأخبرنا بالتفاصيل، وسنوجّه طلبك مباشرة إلى الفريق المختص: التأجير، أو التأجير طويل الأجل، أو النقل المُدار، أو الأساطيل التجارية." />
            <div className="mt-8 flex items-start gap-3 rounded-xl border border-black/[0.06] bg-white p-5">
              <Clock className="w-5 h-5 text-[#EE5A01] flex-shrink-0 mt-0.5" />
              <div><p className="font-heading font-bold text-sm text-[#121212]">أوقات العمل</p><p className="mt-1 font-body text-sm text-[#666666]">الإثنين إلى السبت، ٨:٣٠ صباحاً – ٦:٠٠ مساءً. المساعدة على الطريق ومنصات المطارات على مدار الساعة.</p></div>
            </div>
          </div>
          <div className="lg:col-span-7"><ContactForm lang="ar" /></div>
        </div>
      </section>
    </div>
  );
}
